const PHOTOS = process.env.PUBLIC_URL + '/photos';

export const projectGroups = [
  {
    id: 'tamberma',
    title: 'Pays Tamberma (Togo & Bénin)',
    subtitle: 'Site classé au patrimoine mondial de l’UNESCO, zone d’intervention principale depuis plus de 20 ans.',
    projects: [
      {
        id: 'tamberma-paysage',
        title: 'Le pays Tamberma',
        text: 'Paysages et habitats traditionnels (takyenta) des vallées Tamberma, où l’association concentre l’essentiel de ses interventions.',
        photos: [
          { src: `${PHOTOS}/pays Tamberma/28-DSCF3036.webp` },
          { src: `${PHOTOS}/pays Tamberma/29-DSCF3037.webp` },
          { src: `${PHOTOS}/pays Tamberma/30-IMG_3610.webp` },
          { src: `${PHOTOS}/pays Tamberma/31-IMG_4152.webp` },
          { src: `${PHOTOS}/pays Tamberma/32-IMG_4196.webp` },
          { src: `${PHOTOS}/pays Tamberma/33-IMG_4285.webp` },
          { src: `${PHOTOS}/pays Tamberma/33-IMG_4289.webp` },
          { src: `${PHOTOS}/pays Tamberma/35-P1000170.webp` },
        ],
      },
      {
        id: 'bassmba-2008',
        title: 'Puits de Bassmba — 2008',
        text: 'Construction d’un puits dans le village de Bassmba, en plein cœur du pays Tamberma.',
        photos: [
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/15-DSCF3047.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/16-DSCF3059.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/17-DSCF3128.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/18-IMG_1725.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/19-IMG_4140.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/20-IMG_4480.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/21-IMG_4653.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/22-IMG_4666.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/23-IMG_4668.webp` },
          { src: `${PHOTOS}/puits de Bassmba - Tamberma 2008/24-IMG_4702.webp` },
        ],
      },
      {
        id: 'watema-2017',
        title: 'Puits de Watema — Vallée Tamberma, 2017',
        text: 'Création d’un nouveau puits desservant le village de Watema.',
        photos: [
          { src: `${PHOTOS}/puits de Watema - Vallée Tamberma 2017/9-IMG_0739.webp` },
          { src: `${PHOTOS}/puits de Watema - Vallée Tamberma 2017/10-IMG_0766.webp` },
          { src: `${PHOTOS}/puits de Watema - Vallée Tamberma 2017/11-IMG_0767.webp` },
          { src: `${PHOTOS}/puits de Watema - Vallée Tamberma 2017/12-IMG_0738.webp` },
        ],
      },
      {
        id: 'forage-brousse-2024',
        title: 'Forage en brousse — 2024 / 2025',
        text: 'Campagne de forages en brousse dans le pays Tamberma.',
        photos: [
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/DSCF0910.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/DSCF0913.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/DSCF0914.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/DSCF0916.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/DSCF0928.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/IMG_8642.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/IMG_8651.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/IMG_8659.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/IMG_8660.webp` },
          { src: `${PHOTOS}/forage brousse 2024:2025 Tamberma/IMG_8668.webp` },
        ],
      },
      {
        id: 'nadoba-2025',
        title: 'Nadoba — novembre 2025',
        text: 'Mission de suivi et nouvelle campagne dans le village de Nadoba.',
        photos: [
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0794.webp` },
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0808.webp` },
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0811.webp` },
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0812.webp` },
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0814.webp` },
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0824.webp` },
          { src: `${PHOTOS}/Nadoba nov 2025/DSCF0841.webp` },
        ],
      },
    ],
  },
  {
    id: 'warengo',
    title: 'Warengo',
    subtitle: 'Village du nord Togo où l’association intervient sur l’eau, la santé et l’éducation depuis près de vingt ans.',
    projects: [
      {
        id: 'warengo-gravier-2007',
        title: 'Ramassage et transport du gravier — 2007',
        text: 'Les habitants de Warengo 2 mobilisés pour acheminer depuis la rivière les matériaux nécessaires à la construction.',
        photos: [
          { src: `${PHOTOS}/ramassage gravier à la rivière et transport par les habitants de warengo 2 - 2007/13-ramassage et transport gravier par les habitants IMG_3605.webp` },
          { src: `${PHOTOS}/ramassage gravier à la rivière et transport par les habitants de warengo 2 - 2007/14-IMG_3606.webp` },
        ],
      },
      {
        id: 'warengo-puits-ecole',
        title: 'Puits de l’école de Warengo',
        text: 'Un point d’eau dédié à l’école du village.',
        photos: [
          { src: `${PHOTOS}/puits école de Warengo/36-IMG_4131.webp` },
          { src: `${PHOTOS}/puits école de Warengo/37-IMG_4458.webp` },
          { src: `${PHOTOS}/puits école de Warengo/38-IMG_4461.webp` },
          { src: `${PHOTOS}/puits école de Warengo/39-IMG_4463.webp` },
          { src: `${PHOTOS}/puits école de Warengo/40-IMG_4540.webp` },
          { src: `${PHOTOS}/puits école de Warengo/41-P1060128.webp` },
        ],
      },
      {
        id: 'warengo-medicale-2011',
        title: 'Campagne médicale — 2011',
        text: 'Mission de santé organisée auprès des habitants de Warengo.',
        photos: [
          { src: `${PHOTOS}/campagne médicale Warengo - 2011/25-DSCF0550.webp` },
          { src: `${PHOTOS}/campagne médicale Warengo - 2011/26-IMG_4110.webp` },
          { src: `${PHOTOS}/campagne médicale Warengo - 2011/27-IMG_4114.webp` },
          { src: `${PHOTOS}/campagne médicale Warengo - 2011/54-P1020687.webp` },
          { src: `${PHOTOS}/campagne médicale Warengo - 2011/55-P1020688.webp` },
        ],
      },
      {
        id: 'warengo-livres',
        title: 'Livres pour l’école de Warengo',
        text: 'Soutien à l’éducation : dotation de livres pour les élèves.',
        photos: [
          { src: `${PHOTOS}/livres pour l'école de Warengo/49-école IMG_4466.webp` },
          { src: `${PHOTOS}/livres pour l'école de Warengo/50-P1060022.webp` },
        ],
      },
      {
        id: 'warengo-rehab-2024',
        title: 'Réhabilitation de l’ancien forage — 2024',
        text: 'L’ancien forage de Warengo 2, datant de 2011, remis en état en 2024.',
        photos: [
          { src: `${PHOTOS}/ancien forage Warengo 2 (2011) réhabilité en 2024.webp` },
        ],
      },
    ],
  },
  {
    id: 'cinkanssé',
    title: 'Cinkanssé — frontière Togo / Burkina Faso',
    subtitle: 'Construction puis suivi d’un dispensaire de brousse dans une zone très isolée.',
    projects: [
      {
        id: 'cinkanssé-2010',
        title: 'Construction du dispensaire — 2010',
        text: 'Édification d’un dispensaire pour desservir les villages frontaliers.',
        photos: [
          { src: `${PHOTOS}/construction dispensaire Cinkanssé Togo-Burkina-Faso 2010/1-dispensaire cinkanssé...webp` },
          { src: `${PHOTOS}/construction dispensaire Cinkanssé Togo-Burkina-Faso 2010/2-dispensaire cinkanssé..webp` },
          { src: `${PHOTOS}/construction dispensaire Cinkanssé Togo-Burkina-Faso 2010/3-dispensaire cincanssé.webp` },
        ],
      },
      {
        id: 'cinkanssé-2012',
        title: 'Dispensaire de Cinkanssé — 2012',
        text: 'Le dispensaire en activité, deux ans après son ouverture.',
        photos: [
          { src: `${PHOTOS}/dispensaire Cinkanssé 2012/4-MG_0822.webp` },
          { src: `${PHOTOS}/dispensaire Cinkanssé 2012/5-IMG_0823.webp` },
          { src: `${PHOTOS}/dispensaire Cinkanssé 2012/6-IMG_0834.webp` },
          { src: `${PHOTOS}/dispensaire Cinkanssé 2012/7-IMG_0836.webp` },
        ],
      },
    ],
  },
  {
    id: 'autres',
    title: 'Autres villages',
    subtitle: 'Réalisations menées dans d’autres communautés du Togo.',
    projects: [
      {
        id: 'anfamé-2009',
        title: 'Puits de l’école — Anfamé 2 (Maïmouna), 2009',
        text: 'Un puits pour l’école du village d’Anfamé 2.',
        photos: [
          { src: `${PHOTOS}/puits école - Anfamé 2 (Maïmouna)  2009/42-IMG_4298.webp` },
          { src: `${PHOTOS}/puits école - Anfamé 2 (Maïmouna)  2009/43-P1000192.webp` },
          { src: `${PHOTOS}/puits école - Anfamé 2 (Maïmouna)  2009/44-P1010127.webp` },
          { src: `${PHOTOS}/puits école - Anfamé 2 (Maïmouna)  2009/44-P1060127.webp` },
          { src: `${PHOTOS}/puits école - Anfamé 2 (Maïmouna)  2009/45-.webp` },
          { src: `${PHOTOS}/puits école - Anfamé 2 (Maïmouna)  2009/46-PICT0281.webp` },
        ],
      },
      {
        id: 'tchebebe',
        title: 'Tchébébé — puits et adduction d’eau',
        text: 'Premier puits creusé en 2007, puis travaux d’adduction d’eau pour étendre la distribution dans le village.',
        photos: [
          { src: `${PHOTOS}/puis Tchebebe - 2007.webp` },
          { src: `${PHOTOS}/adduction d'eau à Tchebebe.webp` },
        ],
      },
    ],
  },
];
